<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @del="delall" @save="save" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div id="xpane-0">
                <el-table
					:data="datajson"
                    :loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
                    @row-dblclick="openEdit"
                    @row-click="editInfo"
					border
					stripe
					size="mini"
					:height="tableH"
					header-row-class-name="headerclass"
					style="width: 100%;
                    margin-top:0px"
					ref="singleTable" >
                        <el-table-column show-overflow-tooltip prop="st_code" :label="$t('getapi[463]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="main_tablename" :label="$t('getapi[13029]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="st_status" :label="$t('getapi[552]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[497]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[496]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" width="200"></el-table-column>
				</el-table>
                </div>
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;z-index: 88">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:1100px;min-width: 1100px;overflow:auto">
                    <table>
                        <tr>
                            
                            <td><span>{{ $t('getapi[1861]') }}</span></td>
                            <td><el-input v-model="formInline.st_status" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[13029]') }}</span></td>
                            <td><el-input v-model="formInline.main_tablename" :class="{'readO':formInline.st_status == 1 && addoredit != 1}"
                                          size="mini"></el-input></td>
                        </tr>
                        <tr>
                            
                            <td><span>{{ $t('getapi[409]') }}</span></td>
                            <td><el-input v-model="formInline.create_time" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[734]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.modify_time" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[732]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.audit_person" class="readO" size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[732]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.audit_time" class="readO" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[143]') }}</span></td>
                            <td colspan="7">
                                <el-input type="textarea" v-model="formInline.remark" :placeholder="$t('getapi[143]')"
                                           size="mini"
                                  :readonly="formInline.st_status == 1 && addoredit != 1" :class="{'readO':formInline.st_status == 1 && addoredit != 1}"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>

                <el-row>
                    <el-col :span="24">
                        <div class="box">
                            <div>
                                <el-button type="primary" :disabled="formInline.st_status == 1 && addoredit != 1"
                                           size="mini" @click="addlines">{{ $t('getapi[6467]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="delnew" :disabled="formInline.st_status == 1">
                                    {{ $t('getapi[40]') }}
                                </el-button> 
                             </div>
                        </div>
                        <u-table
                                v-cloak
                                :height="tableHeight - 100"
                                @selection-change="handleSelectionChange"
                                :row-class-name="tableRowClassNameRight"
                                :data="formInline.detail"
                                border
                                size="mini"
                                header-row-class-name="headerclass"
                                style="width: 100%;
                                margin-top:3px"
                                :header-cell-style="$limits.headerClass"
                                id="xdetilpane-0"
                        >
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column prop="sourcetablename" :label="$t('getapi[13030]')" width="150">
                                <template slot-scope="scope">
                                    <el-input class="mcolor"
                                              :disabled="formInline.st_status == 1 && addoredit != 1"
                                              v-model="scope.row.sourcetablename"
                                    ></el-input>
                                </template>
                            </el-table-column> 
                            <el-table-column prop="newtablename" :label="$t('getapi[13031]')" width="150">
                                <template slot-scope="scope">
                                    <el-input class="mcolor"
                                              :disabled="formInline.st_status == 1 && addoredit != 1"
                                              v-model="scope.row.newtablename"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="issubtable" :label="$t('getapi[13032]')" width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.issubtable"
                                                 :disabled="editkeyflag"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="newtable_view" :label="$t('getapi[13033]')" width="150">
                                <template slot-scope="scope">
                                    <el-input class="mcolor"
                                              :disabled="formInline.st_status == 1 && addoredit != 1"
                                              v-model="scope.row.newtable_view"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="filterwhere" :label="$t('getapi[13034]')" width="150">
                                <template slot-scope="scope">
                                    <el-input class="mcolor"
                                              :disabled="formInline.st_status == 1 && addoredit != 1"
                                              v-model="scope.row.filterwhere"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="totaldatarows" :label="$t('getapi[13035]')" width="80">
                            </el-table-column>
                            <el-table-column prop="executiontime" :label="$t('getapi[13036]')" width="100">
                            </el-table-column>
                            <el-table-column prop="remark" :label="$t('getapi[13037]')" width="250">
                            </el-table-column>
                                                    
                            <!-- <el-table-column prop="period_flag" :label="$t('getapi[12412]')">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.period_flag" :disabled="editperiod"></el-checkbox>
                                </template>
                            </el-table-column> -->
                           
                        </u-table>
                    </el-col>
                </el-row>
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        
        
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import { Loading } from 'element-ui'
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        name: 'splittbale',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            },
            tableH(){
                return  this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                formInline: {
                    st_code:'',
                    main_tablename:'',
                    st_status:0,
                    content_desc:'',
                    create_person:'',
                    create_time:'',
                    modify_person:'',
                    modify_time:'',
                    audit_person:'',
                    audit_time:'',
                    remark:'',
                    detail: []
                },
                oldFormInline: '',
                ids: '',
                showloading: '',
                isVisible: false,
                addoredit: 1,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('splittbale'),
                SelectIndex: 0,
                RightSelectIndex: 0, //右侧明细当前页面
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: [], // 右侧选择的数据的ID集合
                selectDataview:[],
                selectData:[],
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                ProPositionList: [],
                rouvisible: false,
                roushowindex: 0,
                rowindex:-1,
                //是否可以编辑
                editf: false,
                //工时费否可以编辑权限
                edithour: false,
                //关键子表
                editkeyflag: false,
                currentRow: null,
                lineid: [],
                userData: [], //用户信息
                user: '', //当前用户
                btn: {
                    //明细行删除
                    rowdel: false,
                    //可用、不可用
                    available: false,
                    //冻结、解冻
                    frozen: false,
                },              
                oldrow: '',
                timeId: null,
                code: '',
                scrollTop:0,
            };
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
            that.$processdata.pushModelCache('splittbale', that);
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            let token = that.userData.token;
            that.oldFormInline = JSON.stringify(that.formInline);
            that.confirmAdd();
            that.$limits.dragControllerDiv();
            that.$nextTick(function () {
                that.$processdata.initForm()
                that.$processdata.initFormRight()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
               
                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                    
            },
            tableRowClassNameRight({row, rowIndex}) {
                row.index = rowIndex;
            },
            //删除行
            delline(e) {
                let line = e.$index;
                if (line > 0) {
                    this.formInline.detail.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            //新增一行工艺清单
            addline(line) {
                let that = this;
                that.formInline.detail[line].add = true;
                let detail = that.formInline.detail;
                let deti = {
                    add: false,
                    exclusively_id:0,
                    st_code:'',
                    sourcetablename:'',
                    newtablename:'',
                    status:0,
                    issubtable:0,
                    newtable_view:'',
                    filterwhere:'',
                    totaldatarows:0,
                    executiontime :'',
                    remark:'',
                };
                let jss = detail[detail.length - 1].add;
                if (jss) {
                    that.formInline.detail.push(deti);
                }
            },
            linedelsel(e) {
                console.log(e);
                this.lineid = [];
                for (var i = 0; i < e.length; i++) {
                    this.lineid.push(e[i].linid);
                }
            },
            //批量删除
            dellines() {
                let that = this;
                let param = {
                    st_code: that.formInline.st_code,
                    details: []
                };
                for (let i = that.selectIDData.length - 1; i >= 0; i--) {
                    that.formInline.detail.splice(that.selectIDData[i].index, 1);
                    if (that.selectIDData[i].exclusively_id != '') {
                        let datatmp = {
                            exclusively_id: that.selectIDData[i].exclusively_id
                        };
                        param.details.push(datatmp);
                    }
                }
                if (param.details.length > 0) {
                    that.loading = true;
                    that.$http.urlpost('Eng/Routings/DelRoutingRow', param, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[284]'));
                            that.intidata();
                        }
                        that.getdlist(that.formInline.st_code, '', '');
                        that.loading = false;
                    });
                }
            },
            // 新增s
            addlines() {
                let that = this;
                let dlength = that.formInline.detail.length;
                let detail = that.formInline.detail;
                let deti = {
                    exclusively_id:0,
                    st_code:'',
                    sourcetablename:'',
                    newtablename:'',
                    status:0,
                    issubtable:0,
                    newtable_view:'',
                    filterwhere:'',
                    totaldatarows:0,
                    executiontime :'',
                    remark:'',
                };

                that.formInline.detail.push(deti);
            },
            // 删除 -- 标准工艺新增工序或删除工序的下挂物料变更
            delnew() {
                let that = this
                if(that.$limits.fnIsEmpty(that.formInline.st_code)){
                    that.dellines()
                } else {
                    let arr = []
                    for(let i = 0;i<that.selectIDData.length;i++){
                        arr = [...arr,{
                            exclusively_id:that.selectIDData[i].exclusively_id
                        }]
                    }
                    let parm = {
                        st_code: that.formInline.st_code,
                        ls: arr
                    }
                    that.$http.urlpost('/Eng/Routings/CheckExistPartDel', parm, function (res) {
                        if (res.Success == 1) {
                            if (res.DataContent == 0) {
                                that.dellines()
                            } else {
                                that.getRoutingSequenceDel()
                            }
                        }
                    });
                }
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('carft',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('Sys/SplitTbale/DataList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.$nextTick(function(){
                            that.$processdata.initForm(that.SelectIndex)
                        });
                    }
                    that.loading = false;
                });
            },
            //加载单据明细
            getdlist(id, name, where) {
                let that = this;
                if (that.$limits.authority('plv2', 28, 1) < 1) {
                    return;
                }
                that.addoredit = 2
                let parm = {
                    Id: 0,
                    Code: id,
                    Name: name,
                    Where: where
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sys/SplitTbale/GetSplitTbaleInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.formInline = res.DataContent.Head;                        
                        that.formInline.detail = res.DataContent.Lists;
                        that.oldFormInline = JSON.stringify(that.formInline);
                    }
                    that.authority();
                    that.$nextTick(function(){
                        that.$processdata.initForm(this.SelectIndex)
                        that.$processdata.initFormRight(this.RightSelectIndex)
                    });
                    loadingInstance.close()
                });
            },

            GetCheckBoxClear() {
                let that = this;
            },
            isRepeat(arr) {
                let hash = {};
                for (let i in arr) {
                    if (hash[arr[i]]) {
                        return true;
                    }
                    hash[arr[i]] = true;
                }
                return false;
            },
            
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            // 保存数据
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = {
                    Head:that.formInline,
                    Lists:that.formInline.detail,
                    LangType:that.$processdata.getLang()
                }
                
                console.log(JSON.stringify(parm));
                that.loading = true;
                that.$http.urlpost('Sys/SplitTbale/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                        that.getdlist(res.UniqueNum, '', '');
                    } 
                    that.loading = false;
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Eng/Routings/QWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },
            //行编辑
            edits(e) {
                let that = this;
                if(that.code == e.row.Exclusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.formInline;
                    for (let i = 0; i < datacopy.detail.length; i++) {
                        delete datacopy.detail[i]['index'];
                    }
                    if (that.oldFormInline != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = e.row
                                that.code = e.row.Exclusively_Id;
                                that.getdlist(that.code, '', '');
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = e.row
                        that.code = e.row.Exclusively_Id;
                        that.getdlist(that.code, '', '');
                    }
                }, 100);
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                let that = this;
                let code = jsd.row.Exclusively_Id;
                that.getdlist(code, '', '');
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = val;
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('Basic/Items/DeleteItemByID', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//此操作将永久删除该数据, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            movef(e) {
                let that = this;
                if (e == '1') {
                    that.formInline.direct_stuff_move_flag = '1';
                } else {
                    that.formInline.direct_stuff_move_flag = '0';
                    that.formInline.move_direction = '';
                }
            },
            //冻结解冻
            enable(e) {
                let that = this;
                if (that.formInline.part_code == '') return;
                let parm = {
                    Id: 0,
                    Code: that.formInline.st_code,
                    Name: '',
                    Where: ''
                };
                if (e) {
                    //冻结
                    that.$http.urlpost('Eng/Routings/FrozenRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            //that.formInline.enable_flag = "0";
                            //that.formInlines.enable_flag = false;
                            that.$message.success(that.$t('getapi[1194]'));
                            that.getdlist(that.formInline.st_code, '', '');
                        }
                    });
                } else {
                    //解冻
                    that.$http.urlpost('Eng/Routings/ThawRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            //that.formInline.enable_flag = "1"; //前后端 出入输出不一致
                            //that.formInlines.enable_flag = true;
                            that.$message.success(that.$t('getapi[1194]'));
                            that.getdlist(that.formInline.st_code, '', '');
                        }
                    });
                }
            },
            // 可用/不可用
            status(e) {
                let that = this;
                if (that.formInline.part_code == '') return;
                let parm = {
                    partid: that.formInline.relation_partmaster_id,
                    routingid: that.formInline.exclusively_id,
                    routingversion: that.formInline.routing_version,
                    Isreplace: 0,
                    iscontinue: 0,
                    LangType: that.$processdata.getLang(),
                };
                if (e == '1') {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = '1'; //可用
                            //that.formInlines.version_status = true;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdlist(that.formInline.st_code, '', ''); //刷左边
                        }
                        else if (res.Success == 2 || res.Success == 3) {
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    parm.iscontinue = res.Success
                                    parm.Isreplace = 1
                                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, function (res1) {
                                        if (res1.Success == 1) {
                                            that.formInline.version_status = '1'; //可用
                                            that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                            that.getdlist(that.formInline.st_code, '', ''); //刷左边
                                        }
                                        else if (res1.Success == 3) {
                                            that.$confirm(that.$processdata.explainCallbackMsg(res1.Msg), that.$t('getapi[194]'), {
                                                confirmButtonText: that.$t('getapi[1146]'),
                                                cancelButtonText: that.$t('getapi[2054]'),
                                                type: 'warning'
                                            })
                                                .then(() => {
                                                    parm.iscontinue = res1.Success
                                                    parm.Isreplace = 1
                                                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, function (res3) {
                                                        if (res3.Success == 1) {
                                                            that.formInline.version_status = '1'; //可用
                                                            that.$message.success(that.$processdata.explainCallbackMsg(res3.Msg));
                                                            that.getdlist(that.formInline.st_code, '', ''); //刷左边
                                                        }
                                                    })
                                                })
                                                .catch(() => {
                                                    that.getdlist(that.formInline.st_code, '', '');
                                                });
                                        }
                                    })
                                })
                                .catch(() => {
                                    that.getdlist(that.formInline.st_code, '', '');
                                });
                        }
                    });
                } else {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = '0'; //不可用
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdlist(that.formInline.st_code, '', '');
                        }
                        else if (res.Success == 2 || res.Success == 3) {
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    parm.iscontinue = res.Success;
                                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, function (res1) {
                                        if (res1.Success == 1) {
                                            that.formInline.version_status = '0'; //不可用
                                            that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                            that.getdlist(that.formInline.st_code, '', '');
                                        }
                                        else if (res1.Success == 3) {
                                            that.$confirm(that.$processdata.explainCallbackMsg(res1.Msg), that.$t('getapi[194]'), {
                                                confirmButtonText: that.$t('getapi[1146]'),
                                                cancelButtonText: that.$t('getapi[2054]'),
                                                type: 'warning'
                                            })
                                                .then(() => {
                                                    parm.iscontinue = res1.Success;
                                                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, function (res2) {
                                                        if (res2.Success == 1) {
                                                            that.formInline.version_status = '0'; //不可用
                                                            that.$message.success(that.$processdata.explainCallbackMsg(res2.Msg));
                                                            that.getdlist(that.formInline.st_code, '', '');
                                                        }
                                                    })
                                                })
                                                .catch(() => {
                                                    that.getdlist(that.formInline.st_code, '', '');
                                                });
                                        }
                                    })
                                })
                                .catch(() => {
                                    that.getdlist(that.formInline.st_code, '', '');
                                });
                        }
                    });
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.formInline;
                for (let i = 0; i < datacopy.detail.length; i++) {
                    delete datacopy.detail[i]['index'];
                }
                if (that.oldFormInline != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//数据已发生变更，是否保存后新建？
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd();
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd();
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.formInline = {
                    st_code:'',
                    main_tablename:'',
                    st_status:0,
                    content_desc:'',
                    create_person:'',
                    create_time:'',
                    modify_person:'',
                    modify_time:'',
                    audit_person:'',
                    audit_time:'',
                    remark:'',
                    detail: [{                            
                        exclusively_id:0,
                        st_code:'',
                        sourcetablename:'',
                        newtablename:'',
                        status:0,
                        issubtable:0,
                        newtable_view:'',
                        filterwhere:'',
                        totaldatarows:0,
                        executiontime :'',
                        remark:'',
                    }]
                };
                that.addoredit = 1;
                that.code = ''
                that.oldFormInline = JSON.stringify(that.formInline);
                that.authority();
            },
            
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ENGROUTINGMASTERViewInfo');
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.intidata(); //刷新左边
                //刷右边
                if (!that.$limits.fnIsEmpty(that.formInline.exclusively_id)) {
                    that.getdlist(that.formInline.exclusively_id, '', '');
                } else {
                    //清空右边
                    that.add();
                }*/
                let that = this;
                let datacopy = that.formInline;
                for (let i = 0; i < datacopy.detail.length; i++) {
                    delete datacopy.detail[i]['index'];
                }
                if (that.oldFormInline != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            that.intidata();
                            if (!that.$limits.fnIsEmpty(that.formInline.st_code)) {
                                that.getdlist(that.formInline.st_code, '', '');
                            } else {
                                //清空右边
                                that.confirmAdd();
                            }
                        });
                } else {
                    that.intidata();
                    if (!that.$limits.fnIsEmpty(that.formInline.st_code)) {
                        that.getdlist(that.formInline.st_code, '', '');
                    } else {
                        //清空右边
                        that.confirmAdd();
                    }
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //导出·
            exp() {
                let that = this;
                that.showloading = that.openLoading();
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //				if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //				}
                });
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/Routings/ListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.showloading.close();
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ENGROUTINGMASTERViewInfo",
                    fromname: that.$t('getapi[64]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            // 物料的工艺存在一个可用版本
            routingtwo() {
                let that = this;
                let parm = {
                    partid: that.formInline.part_code,
                    routingid: that.formInline.Exclusively_Id,
                    routingversion: that.formInline.routing_version
                };
                that.$http.urlpost('Eng/Routings/RoutingTwoEnabledTrue', parm, function (res) {
                    if (res.Success == 1) {
                        // that.$message.success();
                    }
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = '100%';
                } else {
                    left[0].style.width = '100%';
                    mid[0].style.width = '0px';
                }
            },
            
            //查询右侧数据
            editInfo(e) {
                let that = this;
                if(that.code == e.st_code){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.formInline;
                    for (let i = 0; i < datacopy.detail.length; i++) {
                        delete datacopy.detail[i]['index'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = e
                                that.code = e.st_code;
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = e
                        that.code = e.exclusively_id;
                        that.getdlist(that.code,'','');
                    }
                }, 100);
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.datajson.findIndex(item => item.Exclusively_Id === val.Exclusively_Id);
                    this.indf = result;
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            
            checkDataChange() {
                let that = this;
                //能打开此页面即拥有保存权限
                let datacopy = that.formInline;
                for (let i = 0; i < datacopy.detail.length; i++) {
                    delete datacopy.detail[i]['index'];
                }
                let flag = that.oldFormInline != JSON.stringify(datacopy);
                return flag;
            },
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 8px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                margin-right: 5px;
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }
</style>